import { createSlice } from "@reduxjs/toolkit";
import {
    getEvents,
    addEvents,
    updateEvents,
    deleteEvents,
    deleteEventsByUserId
} from './thunk';

export const initialState = {
    event: [],
    errors: {}
};

const CalendarSlice = createSlice({
    name: 'Calendar',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getEvents.fulfilled, (state: any, action: any) => {
            state.event = action.payload || [];
            state.errors = {};
        });
        builder.addCase(getEvents.rejected, (state: any, action: any) => {
            state.error = action.error?.message || 'Failed to fetch events';
            state.event = [];
        });
        builder.addCase(addEvents.fulfilled, (state: any, action: any) => {
            if (action.payload) {
                state.event.unshift(action.payload);
            }
            state.errors = {};
        });
        builder.addCase(addEvents.rejected, (state: any, action: any) => {
            state.error = action.error?.message || 'Failed to add event';
        });
        builder.addCase(updateEvents.fulfilled, (state: any, action: any) => {
            if (action.payload) {
                state.event = state.event.map((event: any) =>
                    event.id === action.payload.id
                        ? { ...event, ...action.payload }
                        : event
                );
            }
            state.errors = {};
        });
        builder.addCase(updateEvents.rejected, (state: any, action: any) => {
            state.error = action.error?.message || 'Failed to update event';
        });
        builder.addCase(deleteEvents.fulfilled, (state: any, action: any) => {
            // Handle deletion - the payload is the event ID
            const eventId = action.payload;
            if (eventId) {
                state.event = state.event.filter(
                    (event: any) => event.id !== eventId
                );
            }
            state.errors = {};
        });
        builder.addCase(deleteEvents.rejected, (state: any, action: any) => {
            state.error = action.error?.message || 'Failed to delete event';
        });
        builder.addCase(deleteEventsByUserId.fulfilled, (state: any, action: any) => {
            // Handle deletion of all events for a specific user
            const userId = action.payload;
            if (userId) {
                state.event = state.event.filter(
                    (event: any) => event.created_by !== userId
                );
            }
            state.errors = {};
        });
        builder.addCase(deleteEventsByUserId.rejected, (state: any, action: any) => {
            state.error = action.error?.message || 'Failed to delete events for user';
        });
    }
});

export default CalendarSlice.reducer;